import { FC, useCallback } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { NavigationRedirect } from 'components/atoms/navigation/NavigationRedirect'
import { openSubscriptionPageActionCreator } from 'actions/floatingPanesActions'
import { useShouldBlockPage } from 'hooks/subscriptionHooks'

type PremiumPageRedirectProps = {

}

export const PremiumPageRedirect: FC<PremiumPageRedirectProps> = (props) => {
  const { children } = props

  const dispatch = useStoreDispatch()
  const handleRedirect = useCallback(() => {
    dispatch(openSubscriptionPageActionCreator())
  }, [dispatch])

  const shouldBlockPage = useShouldBlockPage(window.location.href)

  if (shouldBlockPage === null) {
    return null
  }

  if (shouldBlockPage) {
    return (
      <NavigationRedirect
        to='dashboard'
        push={ false }
        onRedirect={ handleRedirect }
      />
    )
  }

  return (
    <>{ children }</>
  )
}
